import React, { useState, useEffect } from "react";
import MarginBottom from "./MarginBottom";
import video from '../assets/videos/mov_bbb.mp4';
import axios from "../utils/axios";

const VideoSection = () => {
  const [videoLink, setVideoLink] = useState("");
  // const host = "https://admin-l.herokuapp.com/";

  const getVideoLink = async () => {
    try {
      const response = await axios.get(`api/video/getvideolink`);
      const data = response.data;
      if (data.success) {
        setVideoLink(data.video[0].videoLink);
      }else{
        console.log("Error Getting video link");
        console.log()
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getVideoLink();
  }, []);

  return (
    <>
      <h2 className="text-3xl sm:text-4xl my-10 text-center sm:text-left text-lyellow px-[2.3em] font-semibold">
        How To Use
      </h2>
      <div className="flex flex-col lg:flex-row items-center justify-between px-[5em] pb-5">
        <div className="flex justify-center items-center w-full">
          {
            videoLink ? (
              <video
                className="w-[560px] h-[315px]"
                controls
                src={videoLink}
                type="video/mp4"
              />
            ):(
              <video 
                src={video}
                controls
                className="w-[560px] h-[315px]"
          ></video>
            )
          }
          
        </div>
      </div>

      <MarginBottom />
    </>
  );
};

export default VideoSection;
